<div
  class="inline-flex items-center outline-none"
  [ngClass]="{
    'cursor-default': readonly,
    'cursor-not-allowed opacity-50': disabled
  }"
  [attr.role]="readonly ? 'img' : 'slider'"
  [attr.aria-label]="readonly ? rate + ' out of ' + max + ' stars' : 'Rate from 0 to ' + max + ' stars'"
  [attr.aria-valuenow]="rate"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="max"
  [attr.tabindex]="readonly || disabled ? -1 : 0"
  [class.readonly]="readonly"
  [class.disabled]="disabled"
  (mouseleave)="onMouseLeave()">
  <span
    *ngFor="let index of stars"
    [ngClass]="{
      'text-light-gray': !isFilled(index),
      'text-filled': isFilled(index),
      'cursor-pointer': !readonly && !disabled,
      'text-5xl px-1': !readonly
    }"
    (click)="onStarClick(index)"
    (mouseenter)="onStarHover(index)"
    [attr.aria-hidden]="true">
    {{ isFilled(index) ? '★' : '☆' }}
  </span>
</div>
